import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { useAnalytics } from "../analytics/Analytics";
import { ANALYTICS_EVENT } from "../analytics/constants";

const DD_APPLICATION_ID = process.env.REACT_APP_DATADOG_APP_ID;
const DD_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
const DD_SITE = process.env.REACT_APP_DATADOG_SITE || "datadoghq.com";
const DD_SERVICE = process.env.REACT_APP_SERVICE || "invite-landing";
const DD_ENV = process.env.REACT_APP_ENVIRONMENT || "local";

export const DatadogRum = ({ enabled = true, children }) => {
  const { subscribe } = useAnalytics();

  useEffect(() => {
    if (!enabled || enabled === "false" || !DD_APPLICATION_ID || !DD_CLIENT_TOKEN) return;
    if (!window.DD_RUM_INITIALIZED) {
      datadogRum.init({
        applicationId: DD_APPLICATION_ID,
        clientToken: DD_CLIENT_TOKEN,
        site: DD_SITE,
        service: DD_SERVICE,
        env: DD_ENV,
        sampleRate: 100,
        sessionSampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackViewsManually: true,
      });
      window.DD_RUM_INITIALIZED = true;
    }
  }, [enabled]);

  useEffect(() => {
    const unsubscribe = subscribe((eventType, payload) => {
      if (!window.DD_RUM_INITIALIZED) return;
      switch (eventType) {
        case ANALYTICS_EVENT.PAGE_VIEW:
          datadogRum.startView(payload.pathname || payload.name, payload);
          break;
        case ANALYTICS_EVENT.USER_INFO:
          if (!payload || !payload.userId) {
            datadogRum.clearUser();
          } else {
            // Map userId -> id, userEmail -> email, userName -> name, passthrough rest
            const { userId, userEmail, userName, ...rest } = payload || {};
            datadogRum.setUser({
              ...rest,
              id: userId,
              name: userName
            });
          }
          break;
        case ANALYTICS_EVENT.SET_GLOBAL_PARAM:
          datadogRum.setGlobalContextProperty(payload.key, payload.value);
          break;
        case ANALYTICS_EVENT.UNSET_GLOBAL_PARAM:
          datadogRum.removeGlobalContextProperty(payload.key);
          break;
        default:
          datadogRum.addAction(eventType, payload);
          break;
      }
    });
    return unsubscribe;
  }, [subscribe]);

  return children || null;
};

export default DatadogRum;
